<template>
  <div class="formulary-form">
    <div class="field-wrapper" :class="{ fieldWrapperColumn: !inlineLabels }">
      <label v-if="!inlineLabels">Dose</label>
      <md-field class="formulary-dose" data-testid="formulary-dose-container">
        <label v-if="inlineLabels">Dose</label>
        <md-input type="number" min="0" :value="formulary.dose" :disabled="readonly" aria-label="Dose" data-testid="dose-input" @input="value => updateDose(value)" />
      </md-field>
      <help-tooltip v-if="doseError" type="error" aria-label="Dose Error" data-testid="dose-error">
        {{ doseError.message }}
      </help-tooltip>
    </div>
    <div class="field-wrapper" :class="{ fieldWrapperColumn: !inlineLabels }">
      <label v-if="!inlineLabels">Dosing</label>
      <md-field class="formulary-dosing" data-testid="formulary-dosing-container">
        <label v-if="inlineLabels">Dosing</label>
        <md-select :value="formulary.dosing" :disabled="readonly" aria-label="Dosing" data-testid="dosing-select" @input="dosing => updateDosing(dosing)">
          <md-option v-for="dosingType in availableDosingTypes" :key="dosingType.key" :value="dosingType.key" :aria-label="dosingType.label.en" data-testid="dosing-option">
            {{ dosingType.label.en }}
          </md-option>
        </md-select>
      </md-field>
      <help-tooltip v-if="dosingError" type="error" aria-label="Dosing Error" data-testid="dosing-error">
        {{ dosingError.message }}
      </help-tooltip>
    </div>
    <div class="field-wrapper" :class="{ fieldWrapperColumn: !inlineLabels }">
      <md-field v-if="hasVolumeSelect" class="formulary-volume" data-testid="formulary-volume-container">
        <label v-if="inlineLabels">Volume</label>
        <md-select :value="formulary.volume" :disabled="readonly" aria-label="Volume" data-testid="volume-select" @input="volume => updateVolume(volume)">
          <md-option v-for="volume in availableBagVolumes" :key="volume.key" :value="volume.key" :aria-label="volume.label.en" data-testid="volume-option">
            {{ volume.label.en }}
          </md-option>
        </md-select>
      </md-field>
      <help-tooltip v-if="volumeError" type="error" aria-label="Volume Error" data-testid="volume-error">
        {{ volumeError.message }}
      </help-tooltip>
    </div>
  </div>
</template>

<script>
import { infusionBagVolumes, infusionDosingTypes } from '~lib/common/config/medication'
import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'formulary-form',
  components: {
    HelpTooltip
  },
  props: {
    formulary: {
      type: Object,
      required: true,
    },
    volumes: {
      type: Array,
      required: false,
      default: () => [],
    },
    hasVolumeSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
    inlineLabels: {
      type: Boolean,
      default: true,
    },
    allowableDosingTypes: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    availableDosingTypes() {
      return infusionDosingTypes.filter(
        dosingTyp => this.allowableDosingTypes.length === 0 || this.allowableDosingTypes.includes(dosingTyp.key)
      )
    },
    availableBagVolumes() {
      return infusionBagVolumes.filter(
        bagVolume => this.volumes && this.volumes.includes(bagVolume.key)
      )
    },
    doseError() {
      return this.errors.find(e => e.metadata.propertyName.endsWith('dose'));
    },
    dosingError() {
      return this.errors.find(e => e.metadata.propertyName.endsWith('dosing'));
    },
    volumeError() {
      return this.errors.find(e => e.metadata.propertyName.endsWith('volume'));
    },
  },
  methods: {
    updateDose(dose) {
      this.$emit('update', {
        ...this.formulary,
        dose: parseFloat(dose) || 0
      })
    },
    updateDosing(dosing) {
      this.$emit('update', {
        ...this.formulary,
        dosing
      })
    },
    updateVolume(volume) {
      this.$emit('update', {
        ...this.formulary,
        volume
      })
    }
  }
}
</script>

<style scoped>
.formulary-form {
  display: flex;
  flex-direction: row;
}

.field-wrapper {
  display: flex;
}

.fieldWrapperColumn {
  flex-direction: column;
}

.field-wrapper + .field-wrapper {
  margin-left: 16px;
  margin-top: 0;
}

.md-field {
  margin-bottom: 0;
  margin-top: 0;
}
</style>